export enum SalesDispositionGroup {
  open = 'Open',
  won = 'Won',
  dead = 'Dead',
}
